<section *ngIf="this.formGeneratorInput">
    <app-form-generator
        [formGeneratorInput]="formGeneratorInput"
        (formGroupRef)="formGroup = $event"
    ></app-form-generator>
    <app-button-generator></app-button-generator>
</section>
